<nz-tabset [nzSelectedIndex]="selectedIndex" (nzSelectedIndexChange)="onTabChange($event)">
  <nz-tab nzTitle="Collaboration List" *ngIf="authService.hasEntitlements(viewCollaborationRelatedTabs)"></nz-tab>
</nz-tabset>

<div class="tab-content">
  <router-outlet></router-outlet>
</div>
